import { wtClientApi } from 'api/clients';
import type { GenericResponse } from 'commons/modules/generic-response';
import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

type HttpMethod = 'post' | 'put';

interface OnboardingStepMappers<TData, TRequest, TDataDto, TRequestDto> {
  mapRequest?: (body: TRequest) => TRequestDto;
  mapResponse?: (dto: TDataDto) => TData;
}

export const saveOnboardingStep =
  <TData, TRequest, TDataDto = TData, TRequestDto = TRequest>(
    errorMessage: string,
    mappers: OnboardingStepMappers<TData, TRequest, TDataDto, TRequestDto> = {},
  ) =>
  async (
    method: HttpMethod,
    path: string,
    body: TRequest,
  ): Promise<GenericResponse<TData>> => {
    try {
      const payload = mappers.mapRequest ? mappers.mapRequest(body) : body;

      const { data, status } = await wtClientApi[method]<TDataDto>(
        path,
        payload,
      );

      const mappedData = mappers.mapResponse
        ? mappers.mapResponse(data)
        : (data as unknown as TData);

      return adaptDataToGenericResponse(mappedData, status);
    } catch (error: any) {
      return adaptErrorToGenericResponse(error, errorMessage);
    }
  };
